import { apiClient } from "@/services/apiClient";
import type { WorkItem, CreateWorkItemRequest, UpdateWorkItemRequest } from "@/types/workItem";

export async function getWorkItems(
  workspaceId: string,
  listName: string,
  status?: string,
  top?: number
): Promise<WorkItem[]> {
  const params = new URLSearchParams({ workspaceId, listName });
  if (status) params.append("status", status);
  if (top !== undefined) params.append("top", String(top));
  const res = await apiClient.get<WorkItem[]>(`/api/workitems?${params}`);
  return res.data;
}

export async function createWorkItem(request: CreateWorkItemRequest): Promise<WorkItem> {
  const res = await apiClient.post<WorkItem>("/api/workitems", request);
  return res.data;
}

export async function updateWorkItem(
  itemId: string,
  workspaceId: string,
  listName: string,
  request: UpdateWorkItemRequest
): Promise<void> {
  const params = new URLSearchParams({ workspaceId, listName });
  await apiClient.patch(`/api/workitems/${itemId}?${params}`, request);
}

export async function deleteWorkItem(
  itemId: string,
  workspaceId: string,
  listName: string
): Promise<void> {
  const params = new URLSearchParams({ workspaceId, listName });
  await apiClient.delete(`/api/workitems/${itemId}?${params}`);
}
